export default {
  about: {
    title: '公司简介',
    company: '北京龙讯旷腾科技有限公司',
    companyp1: '“龙讯”于2015年在北京成立，公司的目标是为在材料模拟方面的科研团队提供最新的工具和技术，帮助广大科研人员解决相关的问题。',
    companyp2: `“龙讯”将高速发展的计算技术、模拟方式、数学算法注入到强大的材料模拟工具之中，
    从而帮助科研人员和工业研发人员去理解、设计和发现新材料。
    我们研发了软硬件一体化的方案，为客户提供全方位的服务和支持；同时我们也为客户提供培训、合作会议等服务，使我们的客户和“龙讯”一起成长。`,
    team: '我们的团队',
    teamp1: '“龙”之队由顶尖的材料科学家、计算机科学家和硬件工程师组成。',
    teamp2: `我们的团队成员是电子结构计算和算法研究领域的领导者，在新方法和软件工程方面有几十年的经验。
    这也是“龙讯”成立的愿景：将我们对电子结构计算方面的研究成果和最新的研究进展带给我们的客户，使更多的人获益！`,
    solution: '我们的解决方案',
    solutionp1: '强大的 GPU 加速平面波密度泛函软件 PWmat',
    solutionp2: '我们对平面波密度泛函软件在GPU方面进行了深度优化，充分发挥了GPU的加速性能，无论在计算规模还是在计算速度上，都使第一性原理计算都有了质的飞越。',
    solutionp3: '软硬一体机，开箱即用',
    solutionp4: `通过不断对硬件的测试，我们将常见的模拟计算软件Quantum Espresso、Lammps-GPU、可视化软件VESTA预装到自主研发的“MSTATION”上面，
                 为客户提供开箱即用的解决方案，功能强大，真正做到人无我有，人有我快的体验。此外，和CPU集群相比，MSTATION具有高性价比、低功耗、低噪音等特点。`,
    solutionp5: '完善的售后培训和技术支持',
    solutionp6: '龙讯为客户提供有针对性的专业培训，保证客户在购买之后能迅速上手。有专门的客户群，为客户解答平时使用过程中遇到的各种问题，避免遇到问题无人咨询的情况，缩短客户科研周期。',
  },
  companynew: {
    news: '公司动态'
  },
  academic: {
    title: '学术教育方案',
    material: '一站式材料计算服务',
    materialP1: `
          龙讯旷腾自主开发了第一性原理计算软件PWmat、PWmat前后处理工具软件PWkit、
          PWmat在线可视化提交任务软件Q-Flow、浏览器端在线原子尺度建模软件Q-Studio、开源机器学习力场软件PWmat-MLFF等软件产品,
          致力于为高校用户提供从原子尺度建模到材料性质计算、数据可视化以及使用培训的一站式材料计算服务，让用户可以快速轻松上手材料计算。
    `,
    materialP2: `
          同时龙讯旷腾也推出了预装所有上述软件产品的4卡GPU服务器Mstation，用户可开箱即用。
          除了一体机Mstation，龙讯旷腾还推出了SaaS化解决方案Mcloud。Mcloud是龙讯旷腾自建高性能集群和云桌面组成的云平台，
          云平台集成龙讯旷腾所有软件产品，租机时即可使用。针对上述软件产品，龙讯旷腾均有配套培训服务和售后支持服务，购买上述任何龙讯产品
          即可享受免费培训服务，培训包括基础课程、进阶课程和专题课程，适用不同基础用户。
    `,
    solution: '解决方案',
    solutionR0C1: '方案类型',
    solutionR0C2: '方案优势',
    solutionR1C1: '单独软件License',
    solutionR1C2: '免费安装和升级软件，提供软件使用培训和售后支持服务',
    solutionR2C1: '一体机Mstation',
    solutionR2C2: '预装龙讯所有软件产品，以及机器管理和作业调度软件，用户可开箱即用，提供培训和售后支持',
    solutionR3C1: '双机互联Mstation',
    solutionR3C2: '两台单机版Mstation直接ib网线互联组成轻量化的集群,具有高性价比特点，提供培训和售后支持',
    solutionR4C1: '集群化Mcluster',
    solutionR4C2: '由多台MStation、存储服务器及管理节点组成，预装龙讯所有软件、集群管理软件及客户需求开源软件',
    solutionR5C1: '机时租赁Mcloud',
    solutionR5C2: '租赁龙讯超算云Mcloud机时即可使用所有龙讯软件产品，具有随租随用、资源丰富、可扩展性强等特点',
    app: '应用案例',
    partner: '合作高校',
  },
  industrial: {
    title: '行业解决方案',
    background: '行业背景',
    backgroundP1: `
    基于量子力学的第一性原理计算可以从原子尺度计算材料的性质，加深对材料特性的理解，
    为实验提供知道方向，将盲目试错变成理性设计，助力新材料研发，降低研发成本和周期。第一性原理计算已在学术界有30年的应用历史，
    渗透到材料研究的各个方面。近20年来，第一性原理计算在中国也有了长足的发展，相关论文数量呈指数级增长，材料计算在整个材料研发中占比高达20%，市场潜力巨大。
    `,
    demand: '行业需求',
    demandT1: '新能源',
    demandP1: `在碳中和与碳达峰大背景下，新能源是未来20-30年的一个主要工业发展方向，但无论是二次锂电池，还是水分解、氢储存等研究方向均有不同的技术问题，如高容量正负极材料筛选、
            水分解催化剂设计、氢储材料优化设计等，这些问题都需要借助量子力学从原子尺度给出合理的解决方案或建议，新能源属于原子领域，而非机械领域，需要原子尺度的计算模拟`,
    demandT2: '半导体',
    demandP2: `随着器件不断接近原子尺度，连续介质的特性不再成立，原子效应、量子效应明显，摩尔定律就要完结，电子器件不再是一个体材料的电子扩散输运的经典器件，而是一个充满量子效应、
            多物理现象、原子纳米尺度的器件。“More than Moore”时代将是一个研发投入更多的时代。对于半导体器件的研发，原子尺度的计算模拟是必不可少的`,
    demandT3: '化工催化',
    demandP3: `近年来，得益于理论计算的快速发展，基于原子尺度的计算模拟在催化领域的运用日益广泛，
            可帮助研发人员深入研究催化反应过程，更清楚地找到问题所在，解决反应过程中动态微观结构演变、反应路径等问题，助力工业制品的研发`,
    demandT4: '生物制药',
    demandP4: `靶向药的兴起，让小分子药物研发充满生机，疫情告诉我们，社会需要快速开发药物的能力，时间紧迫，生物制药行业已经有几十年分子计算的经验，
            但问题在于传统的材料模拟不够精确，所以如何提供计算精度和准确性是亟需解决的问题`,
    demandT5: '合金',
    demandP5: `合金材料覆盖工业方方面面，企业需要更符合行业需求的合金材料。铁、钛等自身具有结构相变的材料可设计性非常强，通过技术手段可改变其内部原子结构，
            使其强度等特性发生改变，而进行原子尺度的计算模拟，可以使材料内部性质的计算更加精确，提升合金材料的研发效率`,
    app: '应用案例',
    appT1: '案例1：提高高镍三元正极材料循环稳定性',
    appP1: `高镍三元材料由于具有较高的克容量而逐渐成为动力电池的首选材料。但是，在高镍材料的合成和充放电循环过程中容易出现大量的锂镍混排缺陷，导致材料容量快速衰减。
            元素掺杂可以有效改善锂镍混排问题，提高三元材料的容量。龙讯旷腾通过第一性原理计算方法帮助某正极材料公司进行了掺杂元素的筛选。`,
    appT2: '案例2：高镍三元锂正极材料电压平台及容量计算',
    appP2: `高镍三元锂离子电池正极材料LiNi<sub>1−x−y</sub>Co<sub>x</sub>Mn<sub>y</sub>O<sub>2</sub>（NCM）凭借比容量高、成本较低和安全性优良等优势，
            成为研究的热点，被认为是极具应用前景的锂离子动力电池正极材料。
            层状结构NCM中，镍是主要的氧化还原反应元素，因此，提高镍含量可以有效提高NCM的比容量。
            某锂电池材料公司重点发展磷酸铁锂和高镍三元材料，龙讯旷腾用第一性原理计算帮助其计算了高镍三元材料的电压平台和容量。
            通过高通量计算，寻找到了每个浓度下能量相对较低的结构，其平均能量相图揭示了反应过程中能量较稳定的相，计算了稳定性的电压和理论容量。`,
    appT3: '案例3：全固态电池正极包覆材料筛选',
    appP3: `固态电解质与正极材料直接接触时会发生反应，固态电解质被氧化，形成电阻性界面并增加电池阻抗，导致容量快速衰退。为寻找合适的正极包覆材料，抑制这些氧化反应发生，
            龙讯旷腾借助第一性原理计算，帮助某固态电池公司进行正极包覆材料筛选。`,
    appT4: '案例4：硫化物固态电解质筛选',
    appP4: `硫化物电解质相比于氧化物和聚合物电解质具有更高的离子电导率，但稳定性差。元素掺杂是解决硫化物电解质稳定性的一个重要手段，
            龙讯旷腾通过第一性原理计算和机器学习力场方法进行了掺杂元素和掺杂比例的筛选，
            帮助某固态电池公司找到了合适的掺杂元素及可能的配比范围。`,
    appT5: '案例5：CMOS器件模拟',
    appP5: `PWmatTransport采用量子散射态方法计算量子输运，与算法复杂度规模在O(N3)的NEGF方法不同，这种散射态方法可以直接计算给定能量的散射态。
            这种方法可以线性扩展系统大小，因此适用于大型系统的仿真。
            PWmatTransport已被用于模拟具有6nm沟道长度的实际CMOS器件，该体系包含5000个原子。同时，为了模拟真实器件，我们还开发了不同电极采用不同费米能级的非平衡自洽计算方法。`,
    appT6: '案例6：PWmat嵌入农机装备材料研发平台',
    appP6: `农机装备关键材料面临着高强化、耐磨性、耐蚀性、自主率的轴齿轮材料一致性等方面的优化，需要有效突破生产应用中的关键共性技术，提升我国农机制造业整体技术水平。
           龙讯旷腾PWmat能够得出材料性能数据（力学性能、成形性能、成分性能），将性能数据和材料企业提供的材料工艺生产信息交叉对比，加速设计验证新材料。
           PWmat嵌入研发平台不仅能够总结多种农机材料的共性性能要求和共性技术，提高农机材料（乃至机械材料）研发效率，还能探索材料信息平台整合研发的可能，
           和产业链其他企业合作形成材料研发全流程解决方案。`,
    appT7: '案例7：PWmat嵌入钢铁行业研究平台',
    appP7: `由于实验测量高温高压环境金属的相图成本较高、难度较大，产研界考虑通过计算材料的热力学性质进行完整和体系化了解，画出初步相图后就关键点进行实验确认。计算求解的原理为：
            通过求解不同结构的量子力学方程（第一性原理计算），得到材料的吉布斯自由能，确定相图的结构。
            在计算实践中，龙讯旷腾考虑材料本身能量、零点能、材料体积变化、原子振动熵、电子自旋方向熵、电子轨道排布熵等因素，构建了在压强、温度、磁排布等不同环境下计算相图的集成最优方案。
            在中国钢研院项目中，龙讯旷腾在不使用任何实验参数的情况下，仅通过利用以上计算流程得到了与实验相图趋势接近的Ti和Fe的计算相图。进一步利用极少的实验相变点数据，
            使用LDA与PBE交换关联泛函的校准、DFT+U校准等方法，修正密度泛函理论的第一性原理计算结果与实验的误差，得到在所有文献中与实验数据最为接近的第一性原理计算相图。`,
    partner: '合作企业',
  },
  cooperate: {
    banner: '公司简介',
    title: '我们的客户',
    cooperateR1C1: '中国科学院半导体研究所',
    cooperateR1C2: '中国科学院大学物理学院',
    cooperateR1C3: '浙江大学城市学院',
    cooperateR2C1: '浙江大学能源工程学院',
    cooperateR2C2: '中国科学院苏州纳米技术与纳米仿生研究所',
    cooperateR2C3: '中南大学物理与电子学院',
    cooperateR3C1: '华中科技大学光学与电子信息学院',
    cooperateR3C2: '复旦大学物理系',
    cooperateR3C3: '华南师范大学物理与电信工程学院',
    cooperateR4C1: '华南理工大学物理与光电学院',
    cooperateR4C2: '华南理工大学材料科学与工程学院',
    cooperateR4C3: '中国科学院近代物理研究所',
    cooperateR5C1: '湖南大学物理与微电子科学学院',
    cooperateR5C2: '北京科技大学新材料技术研究院',
    cooperateR5C3: '内蒙古大学物理学院',
    cooperateR6C1: '北京大学深圳研究生院',
    cooperateR6C2: '苏州大学能源学院',
    cooperateR6C3: '苏州大学材料学院',
    cooperateR7C1: '华东师范大学物理与电子科学学院',
    cooperateR7C2: '鲁东大学物理与光电工程学院',
    cooperateR7C3: '深圳大学电子科学与技术学院',
    cooperateR8C1: '韩国首尔大学',
    cooperateR8C2: '南方科技大学材料学院',
    cooperateR8C3: '南方科技大学物理学院',
    cooperateR9C1: '韩山师范学院材料系',
    cooperateR9C2: '吉林大学材料科学与工程学院',
    cooperateR9C3: '吉林大学物理学院',
    cooperateR10C1: '中原工学院理学院',
    cooperateR10C2: '武汉大学工业科学研究院',
    cooperateR10C3: '武汉大学机械与动力工程学院',
    cooperateR11C1: '山东大学信息科学与工程学院',
    cooperateR11C2: '南开大学物理学院',
    cooperateR11C3: '南京工业大学先进材料研究院',
    cooperateR12C1: '南京理工大学新型显示材料与器件重点实验室',
    cooperateR12C2: '中国计量大学光学与电子科技学院',
    cooperateR12C3: '中国科学院新疆理化技术研究所',
    cooperateR13C1: '北京信息科技大学理学院',
    cooperateR13C2: '西北大学物理学院',
    cooperateR13C3: '清华大学机械工程系摩擦学国家重点实验室',
    cooperateR14C1: '清华大学化学系',
    cooperateR14C2: '三峡大学材料与化工学院',
    cooperateR14C3: '西南科技大学物理学院',
    cooperateR15C1: '河北大学化学与环境科学学院',
    cooperateR15C2: '济南大学化学院',
    cooperateR15C3: '北卡罗来纳大学夏洛特分校',
    cooperateR16C1: '福州大学材料学院',
    cooperateR16C2: '河北工业大学材料学院',
    cooperateR16C3: '郑州大学化学与分子工程学院',
    cooperateR17C1: '中国科学院长春光学精密机械与物理研究所',
    cooperateR17C2: '新疆大学物理科学与技术学院',
    cooperateR17C3: '人民大学物理学院',
    cooperateR18C1: '东北大学材料学院',
    cooperateR18C2: '东北大学轧制技术及连轧自动化国家重点实验室',
    cooperateR18C3: '中山大学物理学院',
    cooperateR19C1: '广东工业大学物理与光电工程学院',
    cooperateR19C2: '南洋理工大学能源研究所',
    cooperateR19C3: '西安电子科技大学',
    cooperateR20C1: '北京化工大学数理学院',
    cooperateR20C2: '深圳信息职业技术学院',
    cooperateR20C3: '重庆邮电大学理学院',
    cooperateR21C1: '中国矿业大学物理学院',
    cooperateR21C2: '西安建筑科技大学理学院',
    cooperateR21C3: '中国科学院微电子研究所',
    cooperateR22C1: '苏州热工研究所',
    cooperateR22C2: '。。。',
  },
  contract: {
    banner: '联系我们',
    title: '一体化全方位服务',
    sale: '销售',
    saleP1: '“龙讯”主要销售MSTATION、MCLUSTER及PWmat软件包，同时还提供计算机时服务。具体细节请联系我们的销售及售前经理。',
    support: '售后',
    supportP1: '“龙讯”还提供完善的售后服务，具体细节请联系我们的客服。',
    cooperate: '合作',
    cooperateP1: '“龙讯”还提供平面波相关数值软件开发的服务，同时也希望与广大科研人员共同推动国产量子计算模拟软件的发展。',
    contractDetails: '联系方式',
    salePhone: '销售电话：',
    supportPhone: '售后电话：',
    mail: '邮箱：',
    wechat: '微信公众号：',
    wechatText: '公众号搜索“PWmat1”',
    address: '地址：',
    addressText: '北京市海淀区学清路8号科技财富中心A座908室',
  },
  join: {
    banner: '加入我们',
    title: '招贤纳士',
    joinP1: `几年来通过不断推出和完善适应市场的优秀产品和优质服务，
    “龙讯”已经成功在材料模拟计算软件之中占据一席之地。为了提供国内乃至国际上一流的高性能材料模拟计算服务，
    推动国产材料模拟计算软件的发展，现诚邀广大志同道合之士加入龙讯这个大家庭。（本招聘长期有效）`,
    positionAname: '开发工程师',
    positionAtitle: '职位需求',
    positionAtext1: '计算数学、固体物理、凝聚态物理、半导体、材料等相关专业',
    positionAtext2: '硕士研究生及以上学历',
    positionAtext3: '物理基础扎实，熟悉固体能带理论、密度泛函理论',
    positionAtext4: '熟练使用PWmat/VASP/QE计算能带和态密度并在英文期刊发表过相关文章',
    positionAtext5: '掌握Python/Fortran/C/C++等语言的一种或者几种，基于PWmat/VASP/QE等计算软件编写过Python/Fortran/C/C++后处理程序',
    descriptionA: '职位描述',
    descriptionAtext1: '基于PWmat的输入和输出编写相关功能的前处理和后处理Python/Fortran/C/C++脚本',
    descriptionAtext2: '理解客户的需求，按照客户的要求编写基于PWmat的功能模块',
    descriptionAtext3: '编写脚本的技术说明文档，方便用户快速掌握脚本的使用',

    positionBname: '销售岗位客户经理',
    positionBtitle: '职位需求',
    positionBtext1: '物理、材料以及半导体等相关专业，本科及以上学历',
    positionBtext2: '认识路，方位感好，会开车优先',
    positionBtext3: '普通话标准，说话流利',
    positionBtext4: '在校期间给老师办理过科研经费报销手续的优先',
    positionBtext5: '会使用DFT软件并且发表过相关文章的优先考虑',
    descriptionB: '职位描述',
    descriptionBtext1: '新客户发展以及老客户跟进',
    descriptionBtext2: '公司软件产品的推广和销售',
    descriptionBtext3: '制定销售计划，完成销售计划',

    positionCname: '薪酬福利',
    positionCtext1: '年薪不低于25万（税前），销售另议',
    positionCtext2: '五险一金，带薪休假',
    positionCtext3: '额外的饭补、出差补助、入职电脑购置补助',
    positionCtext4: '公司出资，报名参加深度学习AI培训',

    positionDname: '公司优势',
    positionDtext1: '与IT公司相比，作为理论计算的硕士，龙讯旷腾更能发挥你的专业优势，同时工作强度不大，绝对不是996',
    positionDtext2: '搞计算，写程序，本行不丢，未来转互联网企业很容易',
    positionDtext3: '初创公司，早来早占坑，早拿股份，早带团队',
    positionDtext4: '成为精通物理和计算机的复合人才，通过我司培训迅速掌握一区期刊发文章套路',

    positionEname: '简历投递',
    positionEtext1: '投递邮箱',

  }
}